var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_vm._l((_vm.imgPaths),function(image,index){return _c('img',{key:image.id,ref:'slide-'+index,refInFor:true,staticClass:"carousel-slide carousel-slide-deactivated",attrs:{"src":_vm.getImgUrl(image)}})}),_c('img',{staticClass:"carousel-logo",attrs:{"src":_vm.getImgUrl('belasia-carousel-logo.png'),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }